import { BaseTranslation } from 'src/i18n/i18n-types';

export const cta: BaseTranslation = {
  confirm: 'Confirm',
  cancel: 'Cancel',
};
